import React, { createContext } from "react";

const TimeContext = createContext(null);

export default TimeContext;
